/**
 * Builds the list of features a Gravity subscription has: for each feature of the plan, the
 * option the company is on (its own add-on, else the plan override, else the plan default)
 * plus every option it could switch to. The billing screens and the upgrade route both price
 * plans from this list, so they always agree.
 */
export const buildSubscriptionFeatures = ({ productId, productFeatures, featureOptions, overrideFeatures }) => {
  return (
    productFeatures
      ?.filter((feature) => feature.stripeProductId === productId)
      ?.map((feature) => {
        const filteredOptions = featureOptions
          ?.filter((option) => option.featureId === feature.featureId)
          ?.filter((option) => !option.stripeProductId || option.stripeProductId === productId)
          ?.sort((a, b) => +a.option - +b.option);

        const options = filteredOptions?.filter((option) => {
          const value = option?.option;
          const withSameValue = filteredOptions?.filter((el) => el?.option === value);

          if (withSameValue?.length > 1) {
            return option?.stripeProductId === productId;
          }
          return true;
        });

        const overrideFeature = overrideFeatures?.find((feat) => feat.featureId === feature.featureId);

        const value = options?.find((option) => option.id === feature.featureOptionId);
        const overrideValue = options?.find((option) => option.id === feature?.featureValueOverride);
        const companyOverrideValue = options?.find((option) => option.id === overrideFeature?.featureOptionId);

        const overrideObject = companyOverrideValue || overrideValue || {};
        const defaultValues = { defaultOptionId: feature?.featureOptionId, defaultOption: value?.option };

        return { ...value, ...overrideObject, ...defaultValues, options };
      }) || []
  );
};
